<a [routerLink]="['/iackathon-groups']">Retour</a>
<h1>Suivi</h1>
@if (isLoading()) {
      <mat-spinner></mat-spinner>
} @else {
    <mat-form-field>
        <mat-select [value]="selectedSave().id" (valueChange)="onSelectSaveChange($event)">
            @for (group of groupSaves(); track group.id) {
                <mat-option [value]="group.id">{{ group.attributes.content.state.group_name }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <app-iackathon-progress-viewer [save]="selectedSave()" [(activeState)]="activeStep"></app-iackathon-progress-viewer>

    <app-iackathon-step-details [save]="selectedSave()" [step]="activeStep()"></app-iackathon-step-details>
}